import { useMutation, useQueryClient } from '@tanstack/react-query';
import { joinKeyQueryKeys, JoinKeys } from '#api';

export function useAddJoinKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: JoinKeys.addJoinKey,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: joinKeyQueryKeys.lists() });
    },
  });
}

export function useEditJoinKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: JoinKeys.editJoinKey,
    onSuccess: (joinKey) => {
      queryClient.setQueryData(joinKeyQueryKeys.detail(joinKey.id), { data: joinKey });
      void queryClient.invalidateQueries({ queryKey: joinKeyQueryKeys.lists() });
    },
  });
}
